<template>
	<div>
		<div class="thumbs" v-if="existingSrc.length || newImages.length">
			<div class="thumb-wrap" v-for="(src, i) in existingSrc" :key="'e' + i">
				<img :src="src" class="thumb" />
				<button type="button" class="thumb-remove" title="Remove" @click="removeExisting(i)">
					<i class="fas fa-times"></i>
				</button>
			</div>
			<div class="thumb-wrap" v-for="(img, i) in newImages" :key="'n' + i">
				<img :src="img.data" class="thumb" />
				<button type="button" class="thumb-remove" title="Remove" @click="removeNew(i)">
					<i class="fas fa-times"></i>
				</button>
			</div>
		</div>
		<div
			class="dropzone"
			:class="{ 'is-dragover': isDragOver }"
			@dragover.prevent="isDragOver = true"
			@dragleave.prevent="isDragOver = false"
			@drop.prevent="onDrop"
			@click="$refs.fileInput.click()"
		>
			<p class="dropzone-hint">Click or drop image(s) here</p>
		</div>
		<input ref="fileInput" type="file" accept="image/jpeg,image/png,image/webp" multiple class="is-hidden" @change="onFileChange" />
		<p class="help">JPG, PNG or WebP, max 8MB each. At least one image is required.</p>
		<p class="help is-danger" v-if="error">{{ error }}</p>
	</div>
</template>

<script>
const MAX_IMAGE_SIZE = 8 * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export default {
	name: 'ImageManager',
	props: {
		existingSrc: { type: Array, default: () => [] },
		newImages: { type: Array, default: () => [] },
	},
	emits: ['update:existingSrc', 'update:newImages'],
	data() {
		return {
			isDragOver: false,
			error: '',
		};
	},
	methods: {
		removeExisting(index) {
			const copy = this.existingSrc.slice();
			copy.splice(index, 1);
			this.$emit('update:existingSrc', copy);
		},
		removeNew(index) {
			const copy = this.newImages.slice();
			copy.splice(index, 1);
			this.$emit('update:newImages', copy);
		},
		onFileChange(e) {
			this.readFiles(Array.from(e.target.files || []));
			e.target.value = '';
		},
		onDrop(e) {
			this.isDragOver = false;
			this.readFiles(Array.from(e.dataTransfer.files || []));
		},
		readFiles(files) {
			this.error = '';
			files.forEach((file) => {
				if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
					this.error = 'Please use JPG, PNG or WebP images.';
					return;
				}
				if (file.size > MAX_IMAGE_SIZE) {
					this.error = 'One of the images exceeds the 8MB limit.';
					return;
				}
				const reader = new FileReader();
				reader.onload = () => {
					this.$emit('update:newImages', [...this.newImages, { name: file.name, data: reader.result }]);
				};
				reader.readAsDataURL(file);
			});
		},
	},
};
</script>

<style scoped>
.thumbs {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 10px;
}
.thumb-wrap {
	position: relative;
	width: 64px;
	height: 64px;
}
.thumb {
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 4px;
	display: block;
}
.thumb-remove {
	position: absolute;
	top: -6px;
	right: -6px;
	width: 20px;
	height: 20px;
	padding: 0;
	border: none;
	border-radius: 50%;
	background-color: #f14668;
	color: white;
	font-size: 0.65rem;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
.thumb-remove:hover {
	background-color: #d13a55;
}
.dropzone {
	border: 2px dashed #48c78e;
	cursor: pointer;
	padding: 20px 16px;
	min-height: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}
.dropzone.is-dragover {
	background-color: rgba(72, 199, 142, 0.1);
}
.dropzone-hint {
	font-size: 0.85rem;
}
.is-hidden {
	display: none;
}
</style>
